import { MessageCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { BANK_INFO } from "@/data/services";
import { useDraggable } from "@/hooks/useDraggable";
import { useAuth } from "@/contexts/AuthContext";
import { useLanguage } from "@/contexts/LanguageContext";

/* WhatsApp float — sending a message requires a registered, logged-in client. */
export const WhatsAppFloat = () => {
  const drag = useDraggable();
  const { user } = useAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();

  const onClick = (e) => {
    if (!user) {
      e.preventDefault();
      toast(lang === "es" ? "Regístrate gratis para enviarme un mensaje por WhatsApp" : "Sign up for free to message me on WhatsApp");
      navigate("/registro?next=/");
    }
  };

  return (
    <a
      data-testid="whatsapp-float"
      href={user ? BANK_INFO.whatsappLink : "/registro?next=/"}
      target={user ? "_blank" : undefined}
      rel="noreferrer"
      ref={drag.ref}
      onPointerDown={drag.onPointerDown}
      onPointerMove={drag.onPointerMove}
      onPointerUp={drag.onPointerUp}
      onPointerCancel={drag.onPointerCancel}
      onClick={onClick}
      data-draggable="true"
      data-requires-login={user ? "false" : "true"}
      style={drag.style}
      className="fixed bottom-6 right-6 z-40 group cursor-grab active:cursor-grabbing"
      aria-label={lang === "es" ? "Enviar mensaje por WhatsApp" : "Send WhatsApp message"}
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-30" />
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.5)] group-hover:scale-110 transition-transform">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
};
